import { render, staticRenderFns } from "./OtherLoans.vue?vue&type=template&id=5554436e&"
import script from "./OtherLoans.vue?vue&type=script&lang=js&"
export * from "./OtherLoans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports